import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		loadingContainer: {
			height: "100%",
		},
		typeSelect: {
			width: 250
		},
		listingContainer: {
			position: "relative",
		},
		saveError: {
			position: "absolute",
			bottom: "100%",
			left: "0",
			width: "100%",
			whiteSpace: "nowrap"
		}
	} satisfies Record<string, CSSObject>;
};
